/**
 * Routes a server `PassDesignError[]` (from PUT /v1/portal/pass-designs/...) to
 * the editor controls by `path`. The server validatePassDesign is the single
 * source of truth — the client never re-implements cap logic, it only displays
 * what the server returned.
 *
 * Field paths emitted by validatePassDesign:
 *   fields.<group>[i].key     — empty key
 *   fields.<group>[i].value   — empty value
 *   fields.<group>[i]         — currencyCode XOR numberStyle collision (bare row)
 *   fields.<group>            — per-group count cap (no index)
 */

import type { PassDesignError } from '@insurwiz/wallet-core';

import type { FieldGroup } from './fieldEditing';

/** Save is blocked iff any finding is severity:'error'. */
export function hasBlockingError(errors: PassDesignError[]): boolean {
  return errors.some((e) => e.severity === 'error');
}

/** Findings attached to one row: `fields.<group>[i]` exactly, or `fields.<group>[i].<prop>`. */
export function errorsForRow(
  errors: PassDesignError[],
  group: FieldGroup,
  index: number,
): PassDesignError[] {
  const rowPrefix = `fields.${group}[${String(index)}]`;
  return errors.filter((e) => e.path === rowPrefix || e.path.startsWith(`${rowPrefix}.`));
}

/** Findings attached to the group as a whole (the count cap): `fields.<group>` exactly. */
export function errorsForGroup(errors: PassDesignError[], group: FieldGroup): PassDesignError[] {
  return errors.filter((e) => e.path === `fields.${group}`);
}
